export default __webpack_public_path__ + "static/media/zanety.0bd0e7e8.png";